module.exports = __webpack_public_path__ + "static/6.1_kush_and_other_african_kingdoms-67690e8e25f384f0c62e53acf437c2da.pdf";